import { DeviationType } from './enums';

export class YearlySettings {
  month: number;
  monthName: string;
  days: number[];
  startTask: number;
  startType: DeviationType;
  workingDays: number[];
  deviation: number;
  deviationType: DeviationType;
}
